import type { ButtonV2StyleProps } from '@withjoy/joykit';
import { ButtonV2, styled } from '@withjoy/joykit';
import { animationTransitionExt } from '@shared/utils/animationTransition';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledMenuButton = styled(ButtonV2)`
  pointer-events: all;
  min-width: unset;
`;

const menuButton = (isCustomPage?: boolean, topOffset?: number): ButtonV2StyleProps => {
  const topOffsetInRem = pxToRem(topOffset);
  return {
    position: 'fixed',
    zIndex: 'overlay',
    top: isCustomPage ? `calc(${pxToRem(14)} + ${topOffsetInRem})` : `calc(${pxToRem(20)} + ${topOffsetInRem})`,
    transition: animationTransitionExt({ property: 'top', duration: '250ms', timingFunction: 'ease-in-out' }),
    left: pxToRem(20),
    overflow: 'hidden',
    color: 'black',
  };
};

export const styles = {
  button: menuButton,
};
